<dsp-content-card [types]="[ 'select', 'select' ]" [loading]="loading$ | async">
  <atlas-field-select [style.--radius-xsmall]="'4px'" [widthValue]="270" [size]="sizeMedium" *dsp-content-filter
    [id]="'holdings-year-filter'" [label]="'As At Year'" placeholder="Pick One" [multiselectable]="false"
    [options]="yearFilterOptions$ | async" [disabled]="!(years$ | async).length" [(ngModel)]="year"
    (valueChange)="onChangeYear($event)" [clearable]="false">
  </atlas-field-select>

  <atlas-field-select [style.--radius-xsmall]="'4px'" [widthValue]="270" [size]="sizeMedium" *dsp-content-filter
    [id]="'holdings-month-filter'" [label]="'As At Month'" placeholder="Pick One" [multiselectable]="false"
    [options]="monthFilterOptions$ | async" [disabled]="!(months$ | async).length" [(ngModel)]="month"
    (valueChange)="onChangeMonth($event)" [clearable]="false">
  </atlas-field-select>

  <atlas-field-select [style.--radius-xsmall]="'4px'" [widthValue]="270" [size]="sizeMedium" *dsp-content-filter
    [id]="'holdings-option-filter'" [label]="'Select Your Option'" placeholder="Pick One" [multiselectable]="false"
    [options]="optionFilterOptions$ | async" [disabled]="!(years$ | async).length" [(ngModel)]="option"
    (valueChange)="onChangeOption($event)" [clearable]="false">
  </atlas-field-select>

  <ng-container *ngIf="isAtLevel2">
    <atlas-field-select [style.--radius-xsmall]="'4px'" [widthValue]="270" [size]="sizeMedium" *dsp-content-filter
      [id]="'allocation-type-filter'" [label]="'Allocation Type'" placeholder="Pick One" [multiselectable]="false"
      [options]="allocationTypeOptions" [(ngModel)]="allocationType" (valueChange)="onChangeAllocationType($event)"
      [clearable]="false">
    </atlas-field-select>
  </ng-container>

  <div dsp-content>
    <div class="row">
      <div class="columns">
        <atlas-tab-group [fullWidth]="false" class="dsp-holdings-tabs" (selectedIndexChange)="onChangeTab($event)">
          <atlas-tab>
            <ng-template atlas-tab-label>
              <atlas-icon icon="cycle"></atlas-icon>

            </ng-template>
            <atlas-tab-content>
              <div class="row">
                <div class="columns">
                  <div class="dsp-title-container">
                    <h3 class="mos-u-display--inline-block mos-u-spacer--margin-none">
                      Allocations
                    </h3>
                    <atlas-icon *ngIf="(notes$ | async)?.performance !== undefined"
                      class="mos-u-spacer--margin-left-xxsm dsp-holdings-tooltip-trigger" [haloTooltipWithArrow]="true"
                      [haloTooltip]="(notes$ | async)?.holdings" [haloTooltipPosition]="'right'"
                      [haloTooltipShowDelay]="100" [id]="'holdings-note-icon'" [size]="'small'" [icon]="'c-info'"
                      [alt]="'info'" [collection]="'user-interface'">
                    </atlas-icon>
                  </div>
                  <p *ngIf="(date$ | async) && (table$ | async)?.length > 1" class="dsp-subtitle">
                    as at end of {{ date$ | async }}
                  </p>
                </div>
                <div class="columns shrink" [style.margin-left]="'auto'" *ngIf="(table$ | async)?.length > 1">
                  <atlas-dropdown #holdingsDonutDropdown="atlasDropdown" [id]="'toggle-holdings-donut-export'"
                    [icon]="'more_vert'" [iconSize]="sizeMedium" [placement]="dropdownPlacementLeftStart"
                    [iconButtonAlt]="'More options'" [iconAriaTitle]="'More options'"
                    [triggerType]="dropdownTriggerTypeIconButton">
                    <atlas-menu [style.display]="'block'" [style.max-width]="'fit-content'">
                      <atlas-menu-item (click)="holdingsDonutDropdown.menu?.closeMenu($event); onExportPDF()">
                        <a [id]="'holdings-donut-download'">
                          Export as PDF
                        </a>
                      </atlas-menu-item>
                      <atlas-menu-item (click)="holdingsDonutDropdown.menu?.closeMenu($event); onExportCSV()">
                        <a [id]="'holdings-donut-export'">
                          Export as CSV
                        </a>
                      </atlas-menu-item>
                    </atlas-menu>
                  </atlas-dropdown>
                </div>
              </div>
              <h3 *ngIf="(table$ | async)?.length <= 1" class="mos-u-align-center--both" [style.height.px]="100">
                No data available for the selected month and fund
              </h3>
              <div *ngIf="(table$ | async)?.length > 1" class="row mos-u-spacer--padding-bottom-xlg">
                <div class="column small-12 medium-6" [ngClass]="!(isMobile$ | async) ? 'dsp-column' : ''">
                  <div dsp-chart #donutChart [chart]="donut$ | async" class="dsp-donut-container"></div>
                </div>
                <div class="column small-12 medium-6" [ngClass]="!(isMobile$ | async) ? 'dsp-column' : ''">
                  <!-- <atlas-table [customSort]="true" (onSort)="onSort($event)">
                    <thead atlas-table-header #header>
                      <tr atlas-table-row>
                        <th atlas-table-header-cell *ngFor="let col of headers" [columnDef]="col">
                          {{ col.displayLabel }}
                        </th>
                      </tr>
                    </thead>
                    <tbody atlas-table-body>
                      <tr halo-table-row
                        *ngFor=" let row of table$ | async | sort:header.sortOption; let index = index">

                        <td atlas-table-cell [attr.colspan]="index === 0 ? 3 : 1">
                          <span *ngIf="index !== 0">{{ row.name }}</span>
                          <b *ngIf="index === 0">{{ row.name }}</b>
                        </td>
                        <td atlas-table-cell *ngIf="index !== 0" class="mos-u-text-right">
                          <div class="dsp-circle" [style.background-color]="row.color"></div>
                        </td>
                        <td atlas-table-cell *ngIf="index !== 0" class="mos-u-text-right dsp-numeric-font">
                          <span>
                            {{ row.allocation && row.allocation !== '0.0000' ? (row.allocation | decimal) + '%'
                            : '-' }}
                          </span>
                        </td>

                      </tr>
                    </tbody>
                  </atlas-table> -->
                  <atlas-table [customSort]="true" (onSort)="onSort($event)">
                    <thead atlas-table-header #header>
                      <tr atlas-table-row>
                        <th atlas-table-header-cell *ngFor="let col of headers" [columnDef]="col"
                          (click)="onSort({ column: col.column, reverse: header.sortOption?.column === col.column ? !header.sortOption.reverse : false })">
                          {{ col.displayLabel }}
                          <span *ngIf="header.sortOption?.column === col.column">
                            <atlas-icon [icon]="header.sortOption.reverse ? 'arrow-down' : 'arrow-up'"></atlas-icon>
                          </span>
                        </th>
                      </tr>
                    </thead>
                    <tbody atlas-table-body>
                      <tr halo-table-row *ngFor="let row of table$ | async; let index = index">
                        <td atlas-table-cell [attr.colspan]="index === 0 ? 3 : 1">
                          <span *ngIf="index !== 0">{{ row.name }}</span>
                          <b *ngIf="index === 0">{{ row.name }}</b>
                        </td>
                        <td atlas-table-cell *ngIf="index !== 0" class="mos-u-text-right">
                          <div class="dsp-circle" [style.background-color]="row.color"></div>
                        </td>
                        <td atlas-table-cell *ngIf="index !== 0" class="mos-u-text-right dsp-numeric-font">
                          <span>
                            {{ row.allocation && row.allocation !== '0.0000' ? (row.allocation | decimal) + '%' : '-' }}
                          </span>
                        </td>
                      </tr>
                    </tbody>
                  </atlas-table>
                </div>
              </div>
            </atlas-tab-content>
          </atlas-tab>
          <atlas-tab>
            <ng-template atlas-tab-label>
              <atlas-icon icon="block" collection="business-finance"></atlas-icon>
            </ng-template>
            <atlas-tab-content>
              <div class="row dsp-full-width">
                <div class="columns">
                  <div class="dsp-title-container">
                    <h3 class="mos-u-display--inline-block mos-u-spacer--margin-none">
                      Allocations
                    </h3>
                    <atlas-icon *ngIf="(notes$ | async)?.performance !== undefined"
                      class="mos-u-spacer--margin-left-xxsm dsp-holdings-tooltip-trigger" [haloTooltipWithArrow]="true"
                      [haloTooltip]="(notes$ | async)?.holdings" [haloTooltipPosition]="'right'"
                      [haloTooltipShowDelay]="100" [id]="'holdings-note-icon'" [size]="'small'" [icon]="'c-info'"
                      [collection]="'user-interface'" [alt]="'info'">
                    </atlas-icon>
                  </div>
                  <p *ngIf="(date$ | async) && (table$ | async)?.length > 1" class="dsp-subtitle">
                    as at end of {{ date$ | async }}
                  </p>
                </div>
                <div class="columns shrink" [style.margin-left]="'auto'" *ngIf="(table$ | async)?.length > 1">
                  <atlas-dropdown #holdingsTreeDropdown="atlasDropdown" [id]="'toggle-holdings-tree-export'"
                    [icon]="'more_vert'" [iconSize]="sizeMedium" [placement]="dropdownPlacementLeftStart"
                    [iconButtonAlt]="'More options'" [iconAriaTitle]="'More options'"
                    [triggerType]="dropdownTriggerTypeIconButton">
                    <atlas-menu [style.display]="'block'" [style.max-width]="'fit-content'">
                      <atlas-menu-item (click)="holdingsTreeDropdown.menu?.closeMenu($event); onExportPDF()">
                        <a [id]="'holdings-tree-download'">
                          Export as PDF
                        </a>
                      </atlas-menu-item>
                      <atlas-menu-item (click)="holdingsTreeDropdown.menu?.closeMenu($event); onExportCSV()">
                        <a [id]="'holdings-tree-export'">
                          Export as CSV
                        </a>
                      </atlas-menu-item>
                    </atlas-menu>
                  </atlas-dropdown>
                </div>
              </div>
              <h3 *ngIf="(table$ | async)?.length <= 1" class="mos-u-align-center--both" [style.height.px]="100">
                No data available for the selected month and fund.
              </h3>
              <div *ngIf="(table$ | async)?.length > 1" class="row mos-u-spacer--padding-bottom-xlg dsp-full-width">
                <div class="columns mos-u-align-center--both dsp-tree-container">
                  <div dsp-chart #treeChart [chart]="tree$ | async" class="dsp-tree-chart"></div>
                </div>
              </div>
            </atlas-tab-content>
          </atlas-tab>
        </atlas-tab-group>
      </div>
    </div>
  </div>
</dsp-content-card>